import { Box, Heading, Spinner, Alert, AlertIcon, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNonce } from "../../context/NonceContext";

const LegalNotice = () =>  {
  const { t } = useTranslation();
  const { loading, error } = useNonce();

  if (loading) {
    return (
      <Box p={4} display="flex" justifyContent="center" alignItems="center" minH="200px">
        <Spinner size="xl" />
        <Text ml={4}>{t('loading_nonce')}</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Alert status="error">
        <AlertIcon />
        {error}
      </Alert>
    );
  }

  return (
    <Box p={4} borderWidth="1px" borderRadius="lg" overflow="hidden">
      <Heading as="h2" size="lg" mb={4}>
        {t('legal_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('legal_intro')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('legal_company_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('legal_company_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('legal_object_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('legal_object_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('legal_conditions_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('legal_conditions_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('legal_liability_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('legal_liability_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('legal_copyright_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('legal_copyright_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('legal_links_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('legal_links_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('legal_litigation_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('legal_litigation_text')}
      </Text>

      <br/><br/>
      <Heading as="h3" size="md" mb={2}>
        {t('legal_jurisdiction_title')}
      </Heading>

      <Text fontSize="lg" mb={2}>
        {t('legal_jurisdiction_text')}
      </Text>
    </Box>
  );
};

export default LegalNotice;
